import { render, staticRenderFns } from "./InfluenceDetail.vue?vue&type=template&id=13aaa798&scoped=true"
import script from "./InfluenceDetail.vue?vue&type=script&lang=js"
export * from "./InfluenceDetail.vue?vue&type=script&lang=js"
import style0 from "./InfluenceDetail.vue?vue&type=style&index=0&id=13aaa798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aaa798",
  null
  
)

export default component.exports